import { render, staticRenderFns } from "./OpisBlockEdit.vue?vue&type=template&id=557cbee5&"
import script from "./OpisBlockEdit.vue?vue&type=script&lang=js&"
export * from "./OpisBlockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports